import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import type { ZodErrorMap } from 'zod'
import { z, ZodIssueCode } from 'zod'

export const useFormErrors = () => {
  const { t } = useI18n()

  const zodErrorMessages = computed(
    (): ZodErrorMap => (issue, ctx) => {
      let message: string = ctx.defaultError
      switch (issue.code) {
        case ZodIssueCode.invalid_type:
          if (issue.expected === 'string') {
            message = t('forms.required')
          }
          break
        case ZodIssueCode.too_small:
          message = t('forms.not-empty')
          break
        case ZodIssueCode.invalid_string:
          if (issue.validation === 'email') {
            message = t('forms.email-invalid')
          }
          break

        default:
          message = ctx.defaultError
      }
      return { message }
    }
  )

  onMounted(() => {
    z.setErrorMap(zodErrorMessages.value)
  })
}
